export class SuitablePhotosCountVo {
  constructor(
    private readonly lower: number,
    private readonly upper: number | null,
  ) {}

  static create(lower: number | null, upper: number | null) {
    if (lower === null && upper === null) {
      return new SuitablePhotosCountVo(0, 0);
    }

    if (lower === null) {
      return new SuitablePhotosCountVo(0, upper);
    }

    if (lower < 0) {
      throw new Error('Lower must be greater than 0');
    }

    if (upper && upper < lower) {
      throw new Error('Upper must be greater than lower');
    }

    return new SuitablePhotosCountVo(lower, upper);
  }

  public getLower() {
    return this.lower;
  }

  public getUpper() {
    return this.upper;
  }

  public getFormatted() {
    if (this.upper === null) {
      return `${this.lower}+`;
    }

    if (this.lower === this.upper) {
      return `${this.lower}`;
    }

    return `${this.lower}~${this.upper}`;
  }

  public updateLower(lower: number) {
    if (lower < 0) {
      return this;
    }

    if (this.upper !== null && lower > this.upper) {
      return this;
    }

    return new SuitablePhotosCountVo(lower, this.upper);
  }

  public updateUpper(upper: number | null) {
    if (upper !== null && upper < this.lower) {
      return this;
    }

    return new SuitablePhotosCountVo(this.lower, upper);
  }

  public includes(suitablePhotosCount: number): boolean {
    if (this.upper === null) {
      return suitablePhotosCount >= this.lower;
    }

    return suitablePhotosCount >= this.lower && suitablePhotosCount <= this.upper;
  }
}
